const SearchByKeywordsEnum = Object.freeze({
  Čeština: 'Vyhledávání podle klíčových slov...',
  Deutsch: 'Suche nach Schlüsselwörtern...',
  Français: 'Recherche par mots-clés...',
  Slovenčina: 'Vyhľadávanie podľa kľúčových slov...',
  Español: 'Búsqueda por palabras clave...',
  English: 'Search by keywords...',
})

export default SearchByKeywordsEnum
